/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router"
import { Modal, ModalTitle, Step, StepController, TitleSection } from "trux"
import { SelectUser } from "../SaveToProfile/SelectUser"
import { SaveToPlaylist } from "../SaveToProfile/SaveToPlaylist"
import { ConfirmationDialog } from "../../components/ConfirmationDialog"
import { CreateNewPlaylist } from "../SaveToProfile/CreateNewPlaylist"
import "./AddMomentToTraceiD.css"

export const AddMomentToTraceiD = (props) => {
    const history = useHistory()
    const location = useLocation()
    const [userHashKey, setUserHashKey] = useState(null)
    const [collectionHashKey, setCollectionHashKey] = useState(null)
    const [userPlaylistClipId, setUserPlaylistClipId] = useState(null)

    const personalizeMoment = () => {
        if(userPlaylistClipId) {
            if (typeof props.onPersonalize === "function") {
                props.onPersonalize()
                props.onClose()
            } else {
                history.push({
                    pathname: location.pathname.replace("save/profile", "personalize"),
                    state: {
                        userHashKey: userHashKey,
                        playlistHashKey: collectionHashKey,
                        userPlaylistClipId: userPlaylistClipId
                    },
                })
            }
        } else {
            console.error("User Playlist Clip Id not set")
        }
    }

    const showConfirmation = (userKey, collectionKey, clipId) => {
        setUserHashKey(userKey)
        setCollectionHashKey(collectionKey)
        setUserPlaylistClipId(clipId)
        if (typeof props.momentAdded === "function") {
            props.momentAdded(props.selectedUser, userKey, collectionKey, clipId)
        }
    }

    useEffect(() => {
        if (userPlaylistClipId) {
            props.setStep("confirmation")
        }
    }, [userPlaylistClipId])

    return (
        <Modal
            open={true}
            onShadeClick={props.onClose}
            className="add-to-collection-modal"
            trkContext={props.trkContext}
        >
            <StepController step={props.step}>
                <Step name="select-user">
                    <SelectUser
                        onClose={props.onClose}
                        selectFamilyMember={(familyMember) =>
                            props.selectFamilyMember(familyMember)
                        }
                    />
                </Step>

                <Step name="save-to-playlist">
                    <TitleSection
                        onCloseClick={props.onClose}
                        onBackClick={props.relations?.length > 1 ? () => props.setStep("select-user") : null}
                    >
                        <ModalTitle content="Save to a playlist" />
                    </TitleSection>
                    <SaveToPlaylist
                        selectedUser={props.selectedUser}
                        createPlaylist={props.createPlaylist}
                        onClose={props.onClose}
                        showConfirmation={(userKey, collectionKey, clipId) => showConfirmation(userKey, collectionKey, clipId)}
                        moment={props.moment}
                    />
                </Step>

                <Step name="create-playlist">
                    <TitleSection
                        onCloseClick={props.onClose}
                        onBackClick={() => props.setStep("save-to-playlist")}
                    >
                        <ModalTitle content="Create playlist" />
                    </TitleSection>
                    <CreateNewPlaylist
                        selectedUser={props.selectedUser}
                        onClose={props.onClose}
                        showConfirmation={(userKey, collectionKey, clipId) => showConfirmation(userKey, collectionKey, clipId)}
                        moment={props.moment}
                    />
                </Step>

                <Step name="confirmation">
                    <ConfirmationDialog
                      onClose={props.onClose}
                      personalizeMoment={personalizeMoment}
                    />
                </Step>
            </StepController>
        </Modal>
    )
}
